/** Routing paths */
export const HOME_PAGE = "home";
export const LOGIN_PAGE = "sign-in";
export const LOGOUT_PAGE = "logout";
export const UNAUTHORIZED_PAGE = "unauthorized";
export const CONTACTBOOK_PAGE = "contact-book";
export const ITEMSTOCK_PAGE = "item-stock";
export const PAYMENT_TERMS_PAGE = "payment-term";
export const OFFER_PAGE = "offer";
export const INVOICE_PAGE = "invoice";
export const TASK_PAGE = "task";
export const CALENDAR_PAGE = "calendar";
export const DAILY_WORKING_HOURS_PAGE = "daily-working-hours";
export const CONSTRUCTION_SITE_TIME_PAGE = "construction-site-time";
export const SETTINGS_PAGE = "settings";
export const BOOKING_VIEW_PAGE = "booking";
